import React from 'react';

import Link from '@common/Link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const Breadcrumbs = ({data}) => {
  return (
    <div className='d-flex mb-3 p-0'>
      {data.map((item, index, {length}) => {
        if (index !== length-1 && item.text) {
          return (
            <Link key={index} to={item.link} className='d-flex align-items-center text-nowrap'>
              <span>{item.text}</span>
              <FontAwesomeIcon icon={faChevronRight} size={'xs'} className='ms-1 me-1'/>
            </Link>
          )
        } else {
          return (
            <span key={index} className='text-nowrap text-truncate'>{item.text}</span>
          )
        }
    })}
  </div>
  )
}

export default Breadcrumbs
